import { Cart, CartOrganization } from '../../types';

export const SharedCartPages = Cart.Pages;

export const SharedCartPrefix = Cart.StoragePrefix;

export type SharedCartOrganization = CartOrganization;
